/*!

 File: set-gmap.js
 Author: Ember
 Version: 1.0.2
 JS Dependencies:
    jQuery,

 CSS Dependencies:


 Description:
    Basic Google map init

*/

var initGmap = {
    init: function (elTarget) {

        var thisLat = 50,
            thisLong = 2,
            thisZoom = 16,
            thisTitle,
            thisAddr,
            thisUrl;

        thisLat = elTarget.getAttribute('data-map-lat');
        thisLong = elTarget.getAttribute('data-map-long');
        thisZoom = parseInt(elTarget.getAttribute('data-map-zoom'));
        thisTitle = elTarget.getAttribute('data-map-title');
        thisAddr = elTarget.getAttribute('data-map-address');
        thisUrl = elTarget.getAttribute('data-map-url');

        let map;

        async function initMap() {
            // The location of Uluru
            const position = { lat: Number(thisLat), lng: Number(thisLong) };
            // Request needed libraries.
            const { Map } = await google.maps.importLibrary("maps");
            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

            // The map, centered at Uluru
            map = new Map(elTarget, {
                zoom: thisZoom,
                center: position,
                mapId: 'google_map',
                scrollwheel: false,
                zoomControl: true,
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.SMALL
                },
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });

            google.maps.event.addListener(map, 'click', function(event){
                this.setOptions({scrollwheel:true});
              });

              

            // The marker, positioned at Uluru
            const marker = new AdvancedMarkerElement({
                map: map,
                position: position,
                title: "Uluru",
            });

            // create the tooltip and its text
            var infoWindow = new google.maps.InfoWindow();
            var html='<h4>'+thisTitle+'<\/h4><p>'+thisAddr+'<\/p>';
            google.maps.event.addListener(marker, 'click', function() {
                        infoWindow.setContent(html);
                        infoWindow.open(map.map, marker);
                    });

        }

        initMap();

        //
        // var myMap = {
        //     bounds: null,
        //     map: null
        // }
        //
        // myMap.init = function(selector, latLng, zoom) {
        //     var myOptions = {
        //         zoom:zoom,
        //         center: latLng,
        //         scrollwheel: false,
        //         zoomControl: true,
        //         zoomControlOptions: {
        //             style: google.maps.ZoomControlStyle.SMALL
        //         },
        //         mapTypeId: google.maps.MapTypeId.ROADMAP
        //     }
        //     //
        //     this.map = new google.maps.Map(selector, myOptions);
        //     this.bounds = new google.maps.LatLngBounds();
        //     // Center marker on resize
        //     var center;
        //     function calculateCenter() {
        //         center = myMap.map.getCenter();
        //     }
        //     //
        //     google.maps.event.addDomListener(myMap.map, 'click', function() {
        //         this.setOptions({scrollwheel:true});
        //     });
        //     //
        //     google.maps.event.addDomListener(myMap.map, 'idle', function() {
        //         calculateCenter();
        //     });
        //     //
        //     google.maps.event.addDomListener(window, 'resize', function() {
        //         myMap.map.setCenter(center);
        //     });
        // };
        // //
        // myMap.placeMarkers = function() {
        //     // create a new LatLng point for the marker
        //     var point = new google.maps.LatLng(parseFloat(thisLat),parseFloat(thisLong));
        //     // add marker
        //     var marker = new google.maps.Marker({
        //         position: point,
        //         map: myMap.map
        //     });
        //     // create the tooltip and its text
        //     var infoWindow = new google.maps.InfoWindow();
        //     var html='<h4>'+thisTitle+'<\/h4><p>'+thisAddr+'<\/p>';
        //     // add a listener to open the tooltip when a user clicks on one of the markers
        //     google.maps.event.addListener(marker, 'click', function() {
        //         infoWindow.setContent(html);
        //         infoWindow.open(myMap.map, marker);
        //     });
        // };
        // //
        // var myLatLng = new google.maps.LatLng(thisLat, thisLong);
        // myMap.init(elTarget, myLatLng, thisZoom);
        // myMap.placeMarkers();
    }
}
